// extracted by mini-css-extract-plugin
export default {"root":"StartPage_root__cbLpV","navigationBlock":"StartPage_navigationBlock__ihl-f","sectionTitle":"StartPage_sectionTitle__1WI69"};